import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import moment from "moment";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { setUserChange } from "../store/actions/userAction";

const useInputUserChange = () => {
  const { dispatch } = useContext(UserContext);

  const handleInputChange = (name: string, value: any) => {
    dispatch(setUserChange(name, value));
  };

  const handleDatePickerChange = (
    field: string,
    date: MaterialUiPickersDate,
    fieldCheck: string,
    onSuccess?: () => void
  ) => {
    const dateParse = moment(date).format("DD-MM-YYYY");
    if (dateParse !== "Invalid date" || date === null) {
      dispatch(setUserChange(field, date ? dateParse : ""));
      if (onSuccess) onSuccess();
    }
    dispatch(setUserChange(fieldCheck, date?.toString() === "Invalid Date"));
  };

  return { handleInputChange, handleDatePickerChange };
};

export default useInputUserChange;
